export default "/institutions/paypal.svg";